import { JobMembership, JobWorkExperience } from './candidate';

export function genderValidator(gender: string) {
    return ['M', 'F', 'O', 'N'].includes(gender);
}

export function emailValidator(email: string) {
    if (!email) return false;
    const regex = /^\S+@\S+\.\S+$/;
    return regex.test(email);
}

export function passwordValidator(password: string) {
    if (!password) return false;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
}

export const jobWorkExperienceValidator = (workExperience: JobWorkExperience): boolean => {
    return Boolean(
        workExperience.companyTitle.length > 0 &&
            workExperience.title.length > 0 &&
            workExperience.start &&
            (workExperience.isCurrentJob
                ? true
                : workExperience.end &&
                  workExperience.end.getTime() >= workExperience.start.getTime())
    );
};

export const jobMembershipValidator = (membership: JobMembership): boolean => {
    return Boolean(
        membership.organizationName.length > 0 &&
            membership.title.length > 0 &&
            membership.start &&
            (membership.isActive
                ? true
                : membership.end && membership.end.getTime() >= membership.start.getTime())
    );
};
